'use client'

import { Card, CardContent, Grid, Typography } from '@mui/material'
import { Logger } from '@wolfdanepug/common-react'

export default function PlanSummaryCard({ plan }: any) {
	Logger.log('[PlanSummaryCard] plan', plan)
	return (
		<Card elevation={0}>
			<CardContent sx={{ p: 2 }}>
				<Grid container spacing={2}>
					{/* <Grid item xs={4} position="relative">
						<Avatar
							src="https://placehold.co/100"
							sx={{
								width: 80,
								height: 80
							}}
						/>
					</Grid> */}
					<Grid item xs={12}>
						<Typography variant="h6">{plan?.profile?.name}</Typography>
						<Typography variant="body1" fontSize={'12px'}>
							Chicken, Veggies and Grains
						</Typography>
						<Typography variant="caption">{plan.meal} oz. servings</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	)
}
